<header class="header">
  <div class="header__left">
    <button type="button" class="header__menu" (click)="handleMenuToggle()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  @if (currentTimeLabel) {
    <div class="header__clock">
      <span>Current Time</span>
      <strong>{{ currentTimeLabel }}</strong>
    </div>
  }

  <div class="header__actions">
    <label class="app-status-switch header__mode-switch">
      <input
        class="app-status-switch__input"
        type="checkbox"
        [checked]="showBsDateEnabled"
        aria-label="Toggle BS / AD date display"
        (change)="toggleShowBsDate($any($event.target).checked)"
      />
      <span class="app-status-switch__track" aria-hidden="true">
        <span class="app-status-switch__thumb"></span>
        <span class="app-status-switch__label app-status-switch__label--inactive">AD</span>
        <span class="app-status-switch__label app-status-switch__label--active">BS</span>
      </span>
    </label>
    <button
      type="button"
      class="header__action-button"
      [class.header__action-button--active]="darkModeEnabled"
      [attr.aria-pressed]="darkModeEnabled"
      aria-label="Toggle dark mode"
      (click)="toggleDarkMode()"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 12.8A8.5 8.5 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"></path>
      </svg>
    </button>
    <button type="button" class="header__action-button" aria-label="Settings" (click)="handleSettings()">
      <span>⚙</span>
    </button>

    <div class="header__notifications" appClickOutside (appClickOutside)="closeNotifications()">
      <button
        type="button"
        class="header__action-button header__notification-button"
        [class.header__action-button--active]="showNotifications"
        aria-label="Notifications"
        [attr.aria-expanded]="showNotifications"
        (click)="toggleNotifications()"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path>
          <path d="M10 21h4"></path>
        </svg>
        @if (unreadNotificationCount > 0) {
          <span class="header__notification-dot" aria-hidden="true"></span>
          <span class="header__notification-count">{{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}</span>
        }
      </button>

      @if (showNotifications) {
        <div class="header__notifications-popover">
          <div class="header__notifications-header">
            <strong>Notifications</strong>
            <div class="header__notifications-header-actions">
              <span>{{ unreadNotificationCount }} unread</span>
              <button
                type="button"
                class="header__notifications-mark-all"
                [disabled]="!unreadNotificationCount || notificationActionLoading"
                (click)="markAllNotificationsRead()"
              >{{ notificationActionLoading ? 'Marking...' : 'Mark all read' }}</button>
            </div>
          </div>
          @if (notificationLoading) {
            <p class="header__notifications-empty">Loading notifications...</p>
          } @else if (notifications.length) {
            <div class="header__notifications-list">
              @for (notification of notifications; track notification.id) {
                <button type="button" class="header__notification-item" (click)="handleNotificationClick(notification)">
                  <span class="header__notification-item-title">{{ notification.title }}</span>
                  @if (notification.description) {
                    <span
                      class="header__notification-item-description"
                      [title]="notification.description"
                    >{{ getNotificationDescription(notification.description) }}</span>
                  }
                  @if (notification.created_at) {
                    <time
                      class="header__notification-item-date"
                      [attr.datetime]="notification.created_at"
                      [title]="getNotificationTimeTooltip(notification)"
                    >
                      {{ getNotificationRelativeTime(notification.created_at) }}
                    </time>
                  }
                </button>
              }
            </div>
          } @else {
            <p class="header__notifications-empty">No unread notifications</p>
          }
          <div class="header__notifications-footer">
            <button type="button" class="header__notifications-view-all" (click)="viewAllNotifications()">View All</button>
          </div>
        </div>
      }
    </div>

    <div class="header__divider"></div>

    <div class="header__user" appClickOutside (appClickOutside)="closeProfileMenu()">
      <button type="button" class="header__user-button" (click)="toggleProfileMenu()">
        @if (displayUser.profileImageUrl) {
          <img class="header__avatar header__avatar--image" [src]="displayUser.profileImageUrl" [alt]="displayUser.fullName + ' profile image'" />
        } @else {
          <span class="header__avatar">{{ displayUser.initials }}</span>
        }
        <span class="header__user-copy">
          <strong>{{ displayUser.fullName }}</strong>
          <small>{{ displayUser.roleLabel }}</small>
        </span>
        <span class="header__chevron">▾</span>
      </button>

      @if (showProfileMenu) {
        <div class="header__menu-popover">
          <div class="header__menu-header">
            <strong>{{ displayUser.fullName }}</strong>
            <span>{{ displayUser.department }}</span>
          </div>
          <button type="button" class="header__menu-item" (click)="handleMyProfile()">My Profile</button>
          <button type="button" class="header__menu-item" (click)="handleSettings()">Settings</button>
          <button type="button" class="header__menu-item header__menu-item--danger" (click)="handleLogout()">
            Logout
          </button>
        </div>
      }
    </div>
  </div>
</header>
